const mlsEndpoints = {
    getMatchesByMatchId: '/matches/{matchId}',
    getMatchesBySeasonId: '/matches/seasons/{seasonId}?competition_id={competitionId}&per_page=1000',
    getStatisticsByMatchId: '/statistics/clubs/matches/{matchId}',
    getKeyEventsByMatchId: '/matches/{matchId}/key_events',
    getKeyEventsByMatchIdFilterByGoals: '/matches/{matchId}/key_events?event=goals',
    getKeyEventsByMatchIdFilterByCard: '/matches/{matchId}/key_events?event=cards',
    getPossessionByMatchId: '/statistics/clubs/matches/{matchId}/possession?scope=all',
    getSeasons: '/competitions/{competition_id}/seasons',  
    getSeasonStatisticsByCompetitionIdAndSeasonId: '/statistics/clubs/competitions/{competition_id}/seasons/{season_id}?per_page=50',
    getSeasonsByCompetitionId: '/competitions/{competition_id}/seasons',
    getPlayerStatisticsByMatchId: '/statistics/players/matches/{matchId}?per_page=50',
    getPlayersByClubAndSeason: "/players/seasons/{season_id}/clubs/{club_id}?per_page=100",
    getPlayerCareerStatsByPlayerId: "/statistics/players/{player_id}/competitions?&competition_id={competition_id}"
};

export default mlsEndpoints;